module.exports = __webpack_public_path__ + "static/2_1_search-2_SK-900b3bada7304034f48575d71a926e84.svg";